import React from 'react';
import AdminTimunUserImportListContainer from '@src/components/user/list/AdminTimunUserImportListContainer';

const AdminTimunUserImportPage = () => <AdminTimunUserImportListContainer />;

export default AdminTimunUserImportPage;
